module.exports = __webpack_public_path__ + "img/icon-search-light-blue.a0b4a6cb.svg";